import { TimelineEventDto } from '@rcp/types';
import { RestSlice } from '../../redux/rest.slice';
import { localizationService } from 'src/services';

export const timelineEventsSlice = new RestSlice<TimelineEventDto>(
	localizationService.getLocalizedString('screen.timeline.timeline'),
	''
);
export default timelineEventsSlice.rests.reducer;
